import React from 'react';
import { observer, inject } from 'mobx-react';
import Composite from 'app/components/BookElements/Composite';
import { Box } from 'grommet';

function Container() {
  return (
    <Box justify="center" align="center">
      <Composite {...this.props}/>
    </Box>
  );
}

const Component = inject('AppState')(observer(Container));
Component.displayName = 'Cover';
export const CoverComponent = Container;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Cover.js